export default __webpack_public_path__ + "static/media/i_socreated_33.322504ef.gif";